import React from 'react';

const InfoIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.8002 0.200195V19.8002H0.200195V0.200195H19.8002ZM18.2002 1.8002H1.8002V18.2002H18.2002V1.8002ZM10.8002 9.2002V15.8002H9.2002V9.2002H10.8002ZM10.8002 5.97109V7.8002H9.2002V5.97109H10.8002Z" fill="#0862C5"/>
  </svg>
);

export default InfoIcon;
